import { Outlet } from 'react-router-dom';
import { Brand } from './Brand';
import { LanguageSwitcher } from './LanguageSwitcher';

/** Centered shell for the signed-out screens (login / signup / forgot / reset). */
export function AuthLayout() {
  return (
    <div className="auth-shell">
      <Brand />
      <LanguageSwitcher className="auth-lang" />
      <Outlet />
    </div>
  );
}
